import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  finishRaceManagerList: {
    data: []
  },
};

export const finishRaceManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FINISH_RACE_MANAGER:
      return {
        ...state,
        finishRaceManagerList: action.payload,
      };
    default:
      return state;
  }
};
